import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let DeleteServiceThunk = createAsyncThunk(
	"Services/DeleteServiceThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.delete(`api/admin/services/${arg?.id}`);

			return res.data;
		} catch (error) {
			// console.log(error.response.data);
			return rejectWithValue(error.response.data);
		}
	}
);
